import { useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";

import { encryptStorage } from "../../../../constants/EncryptStorage";
import { GetLanguageString } from "../../../helper/Components";
import FundFilter from "../../../helper/SearchFilter/FundFilter";
import SelectUnit from "../../../shared/SelectUnit";
import { ApiUnit } from "../../../unit/ApiUnit";

const ExpenseReportFilters = ({
  values,
  setValues,
  onSubmit,
  loading = false,
  unitNotice = false,
  onUnitChange,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [draftValues, setDraftValues] = useState(values);
  const excludeExUnit = draftValues?.excludeExUnit;

  useEffect(() => {
    setDraftValues(values);
  }, [values]);

  useEffect(() => {
    if (draftValues.unit.value === 0) {
      ApiUnit()
        .getUnit(loggedInUnitId, loggedInUnitId, excludeExUnit)
        .then((res) => {
          const temp = res.data.unitList[0];
          setDraftValues((current) => ({
            ...current,
            unit: {
              value: temp.id,
              label: temp.name,
              label1: temp.unitTypeName,
            },
          }));
        })
        .catch((err) => console.log(err));
    }
  }, [loggedInUnitId, excludeExUnit, draftValues.unit.value]);

  const handleUnitChange = (nextValues) => {
    setDraftValues(nextValues);
    if (onUnitChange) {
      onUnitChange(nextValues);
    }
  };

  const handleSearch = () => {
    if (loading) return;
    setValues(draftValues);
    onSubmit(draftValues);
  };

  return (
    <div className="ibox-content" style={{ overflow: "visible" }}>
      <FundFilter values={draftValues} setValues={setDraftValues} showFullDate />
      <div style={{ position: "relative", zIndex: 30, overflow: "visible" }}>
        <SelectUnit
          values={draftValues}
          setValues={handleUnitChange}
          unitId={draftValues.unit.value}
          excludeExUnit={excludeExUnit}
          inlineWithArrows
          excludeUnitTypes={["Usra", "UsraMuavin", "Munfarid"]}
        />
      </div>
      {unitNotice ? (
        <div
          className="d-flex align-items-center mt-3 mb-1"
          style={{
            backgroundColor: "#EFF6FF",
            border: "1px solid #BFDBFE",
            borderLeft: "4px solid #3B82F6",
            borderRadius: "8px",
            padding: "10px 14px",
            color: "#1E40AF",
            fontSize: "13px",
            fontWeight: "500",
          }}
        >
          <i
            className="fa fa-info-circle me-2"
            style={{ fontSize: "16px", color: "#3B82F6", marginRight: "8px", flexShrink: 0 }}
          />
          <span>
            {<GetLanguageString props="funds_report_select_child_unit_notice" />}
          </span>
        </div>
      ) : null}
      <Row className="m-t-md align-items-center">
        <Col md="12" className="text-right">
          <Button
            color="primary"
            type="button"
            onClick={handleSearch}
            disabled={loading}
            style={{
              minWidth: "120px",
              borderRadius: "8px",
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(26, 179, 148, 0.25)",
            }}
          >
            {<GetLanguageString props="funds_submit" />}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ExpenseReportFilters;
